/**
 * Función para crear una capa vacía/transparente (sin mapa base)
 * @returns {TileLayer} Capa de tipo Tile sin fuente (transparente)
 */

import TileLayer from 'ol/layer/Tile'

export function layerEmpty(props) {
    const {
        name,
        title,
        image,
        type,
        visible = false,
        order,
        opacity = 1.0,
        queryable = false,
        tematica = false,
        group = null,
        minZoom = null,
        maxZoom = null,
    } = props;

    // Build layer options
    const layerOptions = {
        name,
        visible,
        image,
        title,
        source: null, // Sin fuente = capa transparente
        type,
        zIndex: order,
        queryable,
        tematica,
        opacity,
        group,
    };

    // Only add minZoom/maxZoom if they are valid numbers
    if (minZoom !== null && minZoom !== undefined && !isNaN(Number(minZoom))) {
        layerOptions.minZoom = Number(minZoom);
    }
    if (maxZoom !== null && maxZoom !== undefined && !isNaN(Number(maxZoom))) {
        layerOptions.maxZoom = Number(maxZoom);
    }

    const emptyLayer = new TileLayer(layerOptions);
    return emptyLayer;
}
